import EquationValue, {
  variables,
  VariableType,
} from "../../../Model/Value/EquationValue"
import RandomNumberGenerator from "../../RandomNumberGenerator"
import NumberValue from "../../../Model/Value/NumberValue"
import { ProductSign, signs } from "../../../Model/Value/ProductValue"
import ValueGeneratorInterface from "../ValueGeneratorInterface"

export default class ProductEquationValueGenerator implements ValueGeneratorInterface {
  constructor(private readonly randomNumberGenerator: RandomNumberGenerator) {}

  public supports(): boolean {
    return true
  }

  public generate(value: number): EquationValue {
    // a * x = b
    // x * a = b
    const a: number = this.randomNumberGenerator.randomInt(
      2,
      Math.round(Math.sqrt(value)),
    )
    const b: number = value * a

    const sign: ProductSign =
      this.randomNumberGenerator.pick<ProductSign>(signs)

    const templates: string[] = [`a ${sign} x = b`, `x ${sign} a = b`]

    return new EquationValue(
      new NumberValue(a),
      new NumberValue(value),
      new NumberValue(b),
      this.randomNumberGenerator.pick<VariableType>(variables),
      this.randomNumberGenerator.pick<string>(templates),
    )
  }
}
